export const theme = {
	primaryDark: "",
	primaryLight: "",
	primaryHover: "",
};
